import { getAvailableTools } from "./registry";
import {
  scopeKey,
  type ToolId,
  type WorkspaceScope,
} from "../toolExperience/types";
const defaults: ToolId[] = ["briefings", "monitoring", "similarity"];
export const pinStorageKey = (scope: WorkspaceScope) =>
  `lazysem_tool_pins_v1:${scopeKey(scope)}`;
export function normalizePins(value: unknown, role?: string): ToolId[] {
  const available = new Set(getAvailableTools(role).map((t) => t.id));
  const input = Array.isArray(value) ? value : defaults;
  return [
    ...new Set(
      input.filter(
        (id): id is ToolId =>
          typeof id === "string" && available.has(id as ToolId),
      ),
    ),
  ].slice(0, 6);
}
